<template>
    <div class="mb-4 row">

        <div class="col-lg-12 col-md-12">
            <div class="card panel ">
                <div class="card-header border-0">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title mb-0 flex-grow-1">Quotation List</h5>
                        <div class="flex-shrink-0">
                            <button class="btn btn-soft-danger" @click="deleteMultiple"><i class="ri-delete-bin-2-line"></i></button>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive product-create">
                        <table class="table table-custom mb-0">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 40px;">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="checkAll" v-model="checkAllQuotesForDelete">
                                    </div>
                                </th>
                                <th style="width: 140px">Quote #</th>
                                <th style="width: 120px">Date Added</th>
                                <th>Customer Name</th>
                                <th>Item Name</th>
                                <th>Status</th>
                                <th style="width: 220px" v-if="user_type == 1 || role == 'Admin'">Added By</th>
                                <th v-if="is_draft != 1" style="width: 90px">Action </th>
                            </tr>
                            </thead>
                            <template v-if="quotations != null">
                                <template v-for="(quotation, index) in quotations.data">
                                    <QuotationListItem
                                        :bus="bus"
                                        :item="quotation"
                                        :id="index" :user_type="user_type"
                                        :role="role"
                                        :is_draft="is_draft"
                                        :can_delete_quotation="can_delete_quotation"
                                        @changeSelectedQuoteForDelete="changeSelectedQuoteForDelete"
                                        @deleteItem="deleteItem"
                                        @onApproveQuotations="approveQuotations"></QuotationListItem>
                                </template>
                            </template>

                        </table>

                        <div class="btnrow text-left" v-if="quotations != null && quotations.data.length">
                            <template>
                                <div class="overflow-auto">
                                    <b-pagination
                                        v-model="page"
                                        :total-rows="total"
                                        :per-page="per_page"
                                    ></b-pagination>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from "vue";
import { mapState, mapActions, mapGetters  } from 'vuex';

import QuotationListItem from "./QuotationListItem";


export default {
    name: "QuotationList",
    props: ['current_page', 'total', 'per_page', 'quotations', 'user_type', 'role', 'can_delete_quotation', 'is_draft'],
    components: {QuotationListItem},
    created() {
        this.page = this.current_page;
    },
    mounted() {

    },
    data(){
        return {
            bus: new Vue(),
            page: 1,
            selectedQuotesForDelete: [],
            checkAllQuotesForDelete: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        deleteItem(event) {
            this.$emit('deleteItem', event);
        },
        approveQuotations(event){
            this.$emit('onApproveQuotations', event);
        },
        changeSelectedQuoteForDelete(event){
            if(this.selectedQuotesForDelete.includes(event.id)) {
                if(!event.checked) {
                    this.selectedQuotesForDelete.splice(this.selectedQuotesForDelete.indexOf(event.id), 1);
                }
            } else {
                this.selectedQuotesForDelete.push(event.id);
            }
        },
        deleteMultiple() {
            if(this.selectedQuotesForDelete.length === 0) {
                Vue.$confirm({
                    title: 'No quotes selected',
                    message: 'Select at least one quote.',
                    button: {
                        yes: 'Close',
                    },
                    callback: confirm => {
                    }
                });
                return;
            }
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete all selected quotes?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('onDeleteMultiple', this.selectedQuotesForDelete);
                    }

                }
            });
        }
    },
    watch: {
        page: {
            handler: function(value) {
                //if(value != 1){
                    this.$emit('changeCurrentPage', this.page);
                //}
            }
        },
        checkAllQuotesForDelete: {
            handler: function(value) {
                this.bus.$emit('checkQuotesForDelete', value);
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
